import { useFlags } from 'launchdarkly-react-client-sdk';

// LaunchDarkly flag that gates the Add Families / Add-to-billing bulk-import
// flow. Source flag key is `add-families-bulk-import`; the SDK is configured
// with useCamelCaseFlagKeys, so it reads as `addFamiliesBulkImport` here.
//
// Default OFF. When off, the app keeps its existing behavior: the old
// /import/students flow, the plain "Import students" button, and no Dashboard
// billing nudge. Enable for test accounts first, then GA.
export const ADD_FAMILIES_FLAG = 'addFamiliesBulkImport';

export function useAddFamiliesEnabled(): boolean {
  const flags = useFlags();
  return Boolean(flags[ADD_FAMILIES_FLAG]);
}
